import * as React from 'react';

import { action, computed, observable, runInAction } from 'mobx';
import { Provider, inject, observer } from 'mobx-react';

import $ from 'jquery';

import SquareStore from 'tm3-pay/stores/square-store';

import type ProviderStore from 'connect/web/src/stores/provider-store';

interface IProps {
  providerStore?: ProviderStore;
}

@inject('providerStore')
@observer
class SquareWrapper extends React.Component<IProps> {
  @observable hasSquareLoaded: boolean = false;
  @observable isSquareLoading: boolean = false;
  @observable squareStore: SquareStore;

  render() {
    const { providerStore } = this.props;
    if (!this.hasSquareLoaded && !this.isSquareLoading && !!providerStore) {
      this.loadScript(); // naughty but not directly mutating -- copied from stripe as that seems to work
      return this.props.children;
    }

    if (!this.hasSquareLoaded || this.isSquareLoading) {
      return this.props.children;
    }

    if (this.isSquareEnabled) {
      return <Provider squareStore={this.squareStore}>{this.props.children}</Provider>;
    }

    return this.props.children;
  }

  @computed
  private get isSquareEnabled(): boolean {
    const { providerStore } = this.props;
    return (
      this.hasSquareLoaded &&
      !this.isSquareLoading &&
      !!this.squareStore &&
      providerStore!.squareEnabled
    );
  }

  @computed
  private get isSandboxMode(): boolean {
    const { providerStore } = this.props;
    return !!providerStore && providerStore!.isSquareSandboxMode;
  }

  @computed
  private get scriptUrl(): string {
    // may need to be moved to app config
    return this.isSandboxMode
      ? 'https://sandbox.web.squarecdn.com/v1/square.js'
      : 'https://web.squarecdn.com/v1/square.js';
  }

  @action.bound
  private async loadScript(): Promise<void> {
    const { providerStore } = this.props;
    this.isSquareLoading = true;
    try {
      await $.getScript(this.scriptUrl);
      runInAction(() => {
        if (!!providerStore!.squareApplicationId && providerStore!.squareEnabled) {
          this.squareStore = new SquareStore(providerStore!.squareApplicationId || '', true);
        }
        this.hasSquareLoaded = true;
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.isSquareLoading = false;
    }
  }
}

export default SquareWrapper;
